import React, { FC, useCallback } from 'react'
import { Grid, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { FormProvider, useForm } from 'react-hook-form'
import { UpdateClientTypeRequestDto } from '@sparling/financial-common'
import { classValidatorResolver } from '@hookform/resolvers/class-validator'
import { Modal } from '../../../../../components/Modal'
import { InputField } from '../../../../../components/InputField'
import { updateClientTypeRequest } from '../../../../../store/actions'
import { updateClientTypeModal } from '../../../../../store/selectors'

interface ClientTypeUpdateModalProps {
  isOpen: boolean
  modalClose: () => void
}

export const ClientTypeUpdateModal: FC<ClientTypeUpdateModalProps> = ({ isOpen, modalClose }) => {
  const dispatch = useDispatch()
  const { id, currentName } = useSelector(updateClientTypeModal)

  const formMethods = useForm<UpdateClientTypeRequestDto>({
    mode: 'all',
    reValidateMode: 'onChange',
    shouldFocusError: true,
    resolver: classValidatorResolver(UpdateClientTypeRequestDto),
  })

  const {
    handleSubmit,
    formState: { isValid },
    reset,
  } = formMethods

  const onSubmit = useCallback(
    (data) => {
      if (id) dispatch(updateClientTypeRequest({ id, ...data }))
      reset()
      modalClose()
    },
    [dispatch, id, reset, modalClose],
  )

  return (
    <Modal
      title={'Edit Client Type'}
      submitTitle="Update"
      isOpen={isOpen}
      modalClose={modalClose}
      onSubmit={handleSubmit(onSubmit)}
      isSubmitDisabled={!isValid}
      isWidthAuto
    >
      <FormProvider {...formMethods}>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <Typography variant="subtitle2">Current Name:</Typography>
            <Typography variant="body1" fontWeight="bold">
              {currentName || '—'}
            </Typography>
          </Grid>

          <Grid item>
            <InputField inputName="name" inputType="text" labelName="New Name" fullWidth />
          </Grid>
        </Grid>
      </FormProvider>
    </Modal>
  )
}
